var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDev)?_c('v-chip',{staticClass:"ml-4",attrs:{"label":"","small":"","color":_vm.color},domProps:{"textContent":_vm._s(_vm.envName)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }